import React, {Component, Fragment} from 'react';
import autobind from "autobind-decorator";
import * as InitStatus from "../../../constants/common/InitializationStatus";
import fetch from "fetch-retry";
import {jsonResponseHandler} from "../../../utils/FetchHelper";
import classnames from "classnames";
import If from "../../common/control/If";
import moment from "moment";
import {number_format} from "../../../utils/formatter";
import Loading from "../../common/Loading";
import {ellipsis} from "../common/CommonHelper";
import {addPrefix} from "../../../utils/UriUtil"

class ReferrerLogs extends Component {

  constructor(props) {
    super(props);
    this.orderLayerRef;
    this.orderBtnRef;
    this.dateFormat = "YYYY-MM-DD H:mm";
    this.orderByTypes = [{id: "latest", name: "최신순"}, {id: "top", name: "유입순"}];
    this.perListSize = 30;
    this.maxHasMoreCount = 10;
    this.state = this.initState();
    this.changingTimer = null;
  }

  // Default state
  initState() {
    return {
      displayList: [],  // 서비스에 노출된 리스트 변수
      latestList: [],   // 최신순 리스트
      topLogs: [],      // topN 리스트
      apiStatus: InitStatus.INIT_READY,
      activeOrderBy: this.orderByTypes[0],
      isOpenOrderByLayer: false,
      pageNo: 0,
      availableHasMore: false,
    }
  }


  componentDidMount() {
    this.getLogListByType("latest");
    this.getLogListByType("top");
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
    if (this.changingTimer) clearTimeout(this.changingTimer);
  }

  @autobind
  handleClickOutside(event) {
    if (this.orderLayerRef && !this.orderLayerRef.contains(event.target) && !this.orderBtnRef.contains(event.target)) {
      this.setState({isOpenOrderByLayer: false});
    }
  }

  @autobind
  getLogListByType(type) {
    const {dispatch} = this.props;
    this.setState({apiStatus: InitStatus.INIT_DOING}, () => {
      fetch(addPrefix(`/manage/statistics/referrer/${type}/log.json`), {
        credentials: 'include',
        headers: {'Content-Type': 'application/json'},
        retries: 2,
        retryDelay: 300,
        retryOn: [500],
      })
        .then(jsonResponseHandler(dispatch))
        .then(res => res.json())
        .then(res => {

          const list = res.data.hasOwnProperty('result') ? res.data.result : [];

          // 최신순 데이터 저장
          if (type == "latest") {
            this.setState({
              latestList: list,
              apiStatus: InitStatus.INIT_SUCCESS
            }, () => {

              this.handleHasMore(); // 더보기 정책에 의한 리스트 && 더보기 버튼을 setState 한다. (반복되는 로직이기때문에 따로 정의됨)
            });
          }

          // 랭킹순 데이터 저장
          else {
            this.setState({
              topLogs: list,
              topStatus: InitStatus.INIT_SUCCESS
            });
          }
        })
        .catch(e => {
          console.error('error', e);
          this.setState({...this.initState(), apiStatus: InitStatus.INIT_FAIL});
          if (this.state.apiStatus != InitStatus.INIT_FAIL) {
            alert('통계 정보를 조회할 수 없습니다. 잠시 후 다시 시도해 주시기 바랍니다.');
          }

        });
    })
  }


  // 더보기
  @autobind
  handleHasMore() {
    const {pageNo, latestList} = this.state;
    const from = this.perListSize * pageNo;
    const to = this.perListSize * (pageNo + 1);
    const newList = latestList.slice(from, to + 1);
    const newAvailableHasMore = (newList.length > this.perListSize); // 기준치보다 +1개 있으면 더가져올께 있다는 뜻

    // 더보기 있을때
    if (newAvailableHasMore) {
      this.setState((prevState) => ({
        pageNo: prevState.pageNo + 1,
        displayList: prevState.displayList.concat(newList.slice(0, -1)), // 1개더 가져왔으니깐 1개 제거
        availableHasMore: newAvailableHasMore
      }));
    }
    // 더보기 없을때
    else {
      this.setState((prevState) => ({
        displayList: prevState.displayList.concat(newList),
        availableHasMore: newAvailableHasMore
      }));
    }
  }


  // 키워드 디코더
  getDecodeKeyword(keyword) {
    try {
      return (keyword == null) ? "" : decodeURI(keyword).replace(/\+/g, ' ')
    }
    catch (e) {
      return "";
    }
  }


  // 정렬타입 목록
  @autobind
  renderOrderByTypes() {
    const {activeOrderBy, isOpenOrderByLayer} = this.state;
    return <div className={classnames({opt_blog: true, opt_open: isOpenOrderByLayer})} onClick={this.changeOpenOrderByLayer} ref={element => (this.orderBtnRef = element)}>
      <button type="button" className="btn_opt">
        {activeOrderBy.name}
        <span className="ico_blog ico_open"></span>
      </button>
      <div className="layer_opt">
        <ul className="list_opt" ref={element => (this.orderLayerRef = element)}>
          {
            this.orderByTypes.map((item, index) => {
              return <li key={index} className={classnames({on: item == activeOrderBy})}>
                <label className="lab_btn">
                  {item.name}
                  <input type="button" className="btn_g" value={item.name} onClick={() => this.changeActiveOrderByType(item)}/>
                </label>
              </li>
            })
          }
        </ul>
      </div>
    </div>
  }


  // 정렬 타입 변경
  @autobind
  changeActiveOrderByType(orderBy) {
    if (this.changingTimer != null) clearTimeout(this.changingTimer);

    this.setState((prevState) => ({
      apiStatus: InitStatus.INIT_DOING,
      isOpenOrderByLayer: !prevState.isOpenOrderByLayer,
      activeOrderBy: orderBy,
    }));


    // 강제로 로딩을 표시하기 위하여 0.5초 타이머 추가
    this.changingTimer = setTimeout(() => {
      if (orderBy.id == 'latest') {
        this.setState((prevState) => ({
          displayList: [],
          pageNo: 0,
          availableHasMore: false,
          apiStatus: InitStatus.INIT_SUCCESS
        }), () => this.handleHasMore());
      }
      else {
        this.setState((prevState) => ({
          displayList: prevState.topLogs,
          apiStatus: InitStatus.INIT_SUCCESS
        }));
      }
    }, 500)
  }


  // 정렬 타입 레이어 노출 여부
  @autobind
  changeOpenOrderByLayer() {
    this.setState((prevState) => ({
      isOpenOrderByLayer: !prevState.isOpenOrderByLayer
    }));
  }


  // 리스트 렌더링
  renderItems(list) {
    const {availableHasMore, activeOrderBy} = this.state;
    const isLatest = activeOrderBy.id == 'latest';

    return <Fragment>
      <ol className="list_log">
        {list.map((item, index) => {
          const {definedDomain} = item;
          const decodeKeyword = ellipsis(this.getDecodeKeyword(item.keyword), 15, "...");

          return <li key={index}>
            <em className={`ico_blog ico_${definedDomain}`}>{definedDomain}</em>
            <span className="txt_g">
            <a href={item.refUrl} target="_blank" title={item.refUrl}>
              <If condition={decodeKeyword}>[{decodeKeyword}]&nbsp;</If>{item.refUrl}
            </a>
          </span>
            <span className="time_g">
              <If condition={isLatest}>{moment(item.timestamp).format(this.dateFormat)}</If>
              <If condition={!isLatest}>{number_format(item.pv)}</If>
            </span>
          </li>
        })}
      </ol>

      <If condition={availableHasMore && isLatest}>
        <button className="more_info" onClick={this.handleHasMore}><span className="ico_blog">외부 유입 키워드 더보기</span></button>
      </If>
    </Fragment>
  }


  // empty
  renderEmpty() {
    return <p className="noti_empty">유입 경로 데이터가 없습니다.</p>
  }


  // Main 렌더링
  render() {
    const {displayList, apiStatus} = this.state;
    const {isDoing, isFail, isEmpty, isSuccess} = InitStatus.init(apiStatus, displayList);

    return (
      <div className="box_blog box_log">
        <h4 className="tit_sub">로그</h4>
        {this.renderOrderByTypes()}
        <If condition={isEmpty}>{this.renderEmpty()}</If>
        <If condition={!isEmpty && !isDoing}>{this.renderItems(displayList)}</If>
        <If condition={isDoing}><Loading/></If>
      </div>
    );
  }
}

export default ReferrerLogs;
